export default "__VITE_ASSET__4070b9a0__"